// @flow
import AgencyPage from './AgencyPage'
import { connect } from 'react-redux'
import _ from 'lodash'
import * as reducer from '../redux/ducks/agencyPage/reducers'
import type { State } from '../redux/ducks/agencyPage/reducers'
import type { Store } from '../redux/ducks'
import postJson from '../services/postJson'

const IMPORT_ACCOUNTS_URL = '/agencies/agency/import_accounts'

function mapStateToProps(state: Store, ownProps) {
  return {
    ...ownProps,
    ...state.agencyPage
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onInit: (initial: State) => {
      dispatch(reducer.init(initial))
    },
    onChange: (diff: $Shape<State>) => {
      dispatch(reducer.patch(diff))
    },
    onImportAccounts: (importData: Array<Object>) => {
      dispatch(reducer.patch({ isLoading: true }))
      const requestData = _.map(importData, (item) => {
        return {
          ...item,
          import_type: item.importType,
          selected_account_id: item.selectedAccountId
        }
      })
      postJson(IMPORT_ACCOUNTS_URL, { data: requestData })
        .done((response) => {
          if (response.success && response.accounts) {
            dispatch(reducer.patch({ adAccountsList: response.accounts, isModalOpen: false }))
          } else if (!response.success) {
            dispatch(reducer.patch({ importErrors: response.errors }))
          }
        })
        .fail(() => window.alert('Internal error'))
        .always(() => dispatch(reducer.patch({ isLoading: false })))
    }
  }
}

const AgencyPageContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AgencyPage)

export default AgencyPageContainer
